import { Skeleton } from 'antd';
import React from 'react';

interface Props {
  isLoading?: boolean;
  children?: JSX.Element | string;
}

export const CrmSkeleton: React.FC<Props> = (props: Props) => {
  const { isLoading, children } = props;

  const attrs = {
    wrapper: { className: 'crm' },
    header: {
      wrapper: { className: 'crm__header' },
      label: { className: 'crm__header-label' },
      btn: { className: 'crm__header-btn' },
    },
    skeletons: {
      header: {
        loading: isLoading,
        active: true,
        avatar: false,
        paragraph: false,
        title: {
          style: {
            width: 82,
            maxWidth: '100%',
            height: 24,
            borderRadius: 2,
            marginTop: 2,
          },
        },
      },
      label: {
        loading: isLoading,
        active: true,
        avatar: false,
        paragraph: false,
      },
      value: {
        loading: isLoading,
        active: true,
        avatar: false,
        paragraph: false,
      },
    },
  };

  const inputRow = (width: number) => {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginTop: '11px',
        }}
      >
        <div>
          <Skeleton
            {...attrs.skeletons.label}
            title={{
              style: {
                width: `${width}px`,
                height: 12,
                borderRadius: 2,
                marginTop: 0,
              },
            }}
          />
        </div>
        <div>
          <Skeleton
            {...attrs.skeletons.value}
            title={{
              style: {
                width: 18,
                height: 18,
                borderRadius: '50%',
                marginTop: 0,
                marginRight: 7,
              },
            }}
          />
        </div>
      </div>
    );
  };

  return (
    <>
      {isLoading ? (
        <div {...attrs.wrapper}>
          <div {...attrs.header.wrapper}>
            <div>
              <Skeleton {...attrs.skeletons.header} />
            </div>

            <div>
              <Skeleton {...attrs.skeletons.header} />
            </div>
          </div>
          {/* <div {...attrs.bodyWrapper}>s</div> */}
          {inputRow(100)}
          {inputRow(80)}
          {inputRow(120)}
          {inputRow(150)}
        </div>
      ) : (
        children
      )}
    </>
  );
};
